import React from "react";
import globalSearchIcon from '../../../assets/img/svg/global-search-icon.svg';
import PropTypes from 'prop-types';
import translation from "../../../utils/translation";

const SearchInput = ({placeholder = `${translation('key_search')}`}) => (
    <div className="searchInput">
        <img src={globalSearchIcon} alt="search-icon" />
        <input
            className="form-control mr-sm-2"
            type="search"
            placeholder={placeholder}
            aria-label="Search"
        />
    </div>
);
SearchInput.propTypes = {
    placeholder: PropTypes.string,
};
export default SearchInput;